/**
 * EN content for the "Verdon" private excursion.
 *
 * Role: English translation of slugs/verdon.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import verdon from "@/assets/images/excursions/destinations/verdon.webp";

const page: ExcursionPage = {
  slug: "verdon",
  hero: {
    title: "Verdon Excursion",
    subtitle:
      "The Verdon Gorges and azure lakes: grand nature, departing from Cannes.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: verdon,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "The Verdon Gorges and dizzying cliffs" },
      { text: "Turquoise lakes and viewpoints" },
      { text: "Provençal villages as an option" },
      { text: "Panoramic roads and landmark bridges" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Drive towards the Verdon",
        description: "Panoramic stops.",
      },
      {
        title: "Viewpoints",
        description: "Photos, free time depending on the weather.",
      },
      {
        title: "Lake (optional)",
        description: "Sainte-Croix / St-Cassien depending on the route.",
      },
      { title: "Return", description: "Comfort and safety." },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "8 to 10 hours" },
      { label: "Tip", value: "Bring water and sun protection" },
      { label: "Departure", value: "Cannes" },
      { label: "Footwear", value: "Bring suitable shoes" },
    ],
  },
  seo: {
    title: "Verdon Gorges Excursion from Cannes | Private Chauffeur",
    description:
      "Private full-day excursion from Cannes to the Verdon Gorges: dizzying cliffs, turquoise lakes, panoramic roads and Provençal villages.",
    canonical: "/en/excursions/verdon",
  },
};

export default page;
